import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { DisabledProps, linkMixin } from 'ui/Styled/Styled';
import { TextS } from 'ui/Styled/Styled';

type LinkProps = Omit<React.ComponentProps<typeof RouterLink>, 'ref'>;

const StyledLink = styled(RouterLink)`
    ${linkMixin}
`;

const StyledRawLink = styled.a<DisabledProps>`
    ${linkMixin}
`;

export const StyledTextLink = styled.div<DisabledProps>`
    ${linkMixin}
`;

export const Link = ({ children, ...props }: LinkProps) => {
    return (
        <StyledLink {...props}>
            <TextS>{children}</TextS>
        </StyledLink>
    );
};

type RawLinkProps = {
    disabled?: boolean;
    onClick?: () => void;
    href?: string;
    children: React.ReactNode;
};

export const RawLink = ({ children, disabled, ...props }: RawLinkProps) => {
    const content = <TextS>{children}</TextS>;

    return props.href ? (
        <StyledRawLink $disabled={disabled} {...props}>
            {content}
        </StyledRawLink>
    ) : (
        <StyledTextLink $disabled={disabled} {...props}>
            {content}
        </StyledTextLink>
    );
};
